import { render } from "./liveReorg.vue?vue&type=template&id=6a1c647e&lang=true"
import script from "./liveReorg.vue?vue&type=script&lang=js"
export * from "./liveReorg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__